import { css } from "@emotion/react";
import * as Feather from "react-feather";

const toPascalCase = (text) => {
  return text.replace(/(^\w|-\w)/g, clearAndUpper);
};

const clearAndUpper = (text) => {
  return text.replace(/-/, "").toUpperCase();
};

const ArrowUpDown = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="m21 16-4 4-4-4" />
    <path d="M17 20V4" />
    <path d="m3 8 4-4 4 4" />
    <path d="M7 4v16" />
  </svg>
);

const customIcons = {
  "arrow-up-down": ArrowUpDown,
};

const Icon = ({ name }) => {
  const SelectedIcon = customIcons[name] || Feather[toPascalCase(name)];
  return (
    <SelectedIcon
      css={css`
        height: 1.25em;
        width: 1.25em;
        stroke-width: 1.75px;
      `}
    />
  );
};

export default Icon;
